module.exports = __webpack_public_path__ + "img/blue-flower.ac280dd4.jpeg";